import { apiClient as api } from "./httpClient";

// weekday: 0=domingo … 6=sábado; minutos a partir da meia-noite (mesma convenção de BusinessHour).
export interface AvailabilityRange {
  id: string;
  weekday: number;
  startMinute: number;
  endMinute: number;
  holidayWork: boolean;
  notes?: string | null;
}

export interface AvailabilityRangePayload {
  id?: string | null;
  weekday: number;
  startMinute: number;
  endMinute: number;
  holidayWork: boolean;
  notes?: string | null;
}

export interface EntityOpenHour {
  weekday: number;
  startMinute: number;
  endMinute: number;
}

export interface ProfessionalAvailability {
  ranges: AvailabilityRange[];
  businessHours: EntityOpenHour[];
}

export const professionalAvailabilityService = {
  get: async (professionalRegistration: string): Promise<ProfessionalAvailability> => {
    const response = await api.get(
      `/professional-availabilities/${professionalRegistration}`
    );
    return {
      ranges: response.data?.ranges ?? [],
      businessHours: response.data?.businessHours ?? [],
    };
  },

  set: async (
    professionalRegistration: string,
    ranges: AvailabilityRangePayload[]
  ): Promise<void> => {
    await api.put(`/professional-availabilities/${professionalRegistration}`, {
      ranges,
    });
  },
};
